import { Message as gqlMessage } from '@app/data/cart-bff';
import {
  Message as MonolithMessage,
  Severity as MonolithSeverity,
  Type as MonolithType,
} from '@app/types/monolith/cart';
import { ObjectValues } from '../../types';
import { type Message, MessageSeverity, MessageType } from './types';

const SHIPPING_MESSAGE_TYPES: MessageType[] = [
  MessageType.FreeShippingOnProductApplied,
  MessageType.FlatRateShippingApplied,
];

export const isShippingMessage = ({ type }: Message) =>
  Boolean(type && SHIPPING_MESSAGE_TYPES.includes(type));

export const isNotShippingMessage = (message: Message) =>
  !isShippingMessage(message);

export const isFlatRateShippingApplied = ({ type }: Message) =>
  Boolean(type && type === MessageType.FlatRateShippingApplied);

export const isExpiredProductRemoval = ({ type }: Message) =>
  Boolean(type && type === MessageType.ExpiredProductRemoval);

export const isNonsaleableProductRemoval = ({ type }: Message) =>
  Boolean(type && type === MessageType.NonsaleableProductRemoval);

export const isAppliedMessage = ({ applied }: Message) => applied;

export const mapCartMessageFromGQL = (message: gqlMessage): Message => {
  return {
    actionUrl: message.actionUrl || undefined, // map null to undefined
    applied: message.applied,
    productName: message.productName || undefined, // map null to undefined
    severity: message.severity,
    text: message.text || undefined, // map null to undefined
    type: message.type,
  };
};

const typeMap: Record<ObjectValues<typeof MonolithType>, MessageType> = {
  [MonolithType.ProductWarning]: MessageType.ProductWarning,
  [MonolithType.DiscountSitewide]: MessageType.DiscountSitewide,
  [MonolithType.DiscountVolume]: MessageType.DiscountVolume,
  [MonolithType.DiscountShipping]: MessageType.DiscountShipping,
  [MonolithType.FreeShippingOnProductApplied]:
    MessageType.FreeShippingOnProductApplied,
  [MonolithType.FlatRateShippingApplied]: MessageType.FlatRateShippingApplied,
  [MonolithType.NonsaleableProductRemoval]:
    MessageType.NonsaleableProductRemoval,
  [MonolithType.ExpiredProductRemoval]: MessageType.ExpiredProductRemoval,
};

const severityMap: Record<
  ObjectValues<typeof MonolithSeverity>,
  MessageSeverity
> = {
  [MonolithSeverity.Info]: MessageSeverity.Information,
  [MonolithSeverity.Success]: MessageSeverity.Success,
  [MonolithSeverity.Warning]: MessageSeverity.Warning,
  [MonolithSeverity.Error]: MessageSeverity.Error,
};

export const mapCartMessageFromMonolith = (
  message: MonolithMessage
): Message => {
  return {
    actionUrl: message.action_url,
    applied: message.applied,
    productName: message.product_name || undefined, // map null to undefined
    severity: severityMap[message.severity],
    text: message.text,
    type: typeMap[message.type],
  };
};
